import { type FieldContentsData } from 'javascripts/shared-types';
import Field, { type Flavor } from '../../Field';
import terminology from 'javascripts/terminology';
import { type CardLayoutModelConstructorType } from '../../types';

export class InitiativeIcon extends Field {
  static get availableForFlavors(): readonly Flavor[] {
    return ['roadmap'];
  }

  static subqueriesForModel(
    modelClass: CardLayoutModelConstructorType
  ): Record<string, any> {
    if (modelClass.typename === 'Release') {
      return { initiatives: ['color'] };
    }

    return { initiative: ['color'] };
  }

  get title() {
    return `${terminology('Initiative')} icon`;
  }

  exampleContents(): FieldContentsData {
    return { icon: { name: 'fa-regular fa-sitemap', color: '#9A40BF' } };
  }

  contentsForRecord(record): FieldContentsData {
    let { initiative } = record;
    if (record.typename === 'Release' && record.initiatives) {
      initiative = record.initiatives[0];
    }

    if (initiative) {
      return {
        icon: {
          name: 'fa-regular fa-sitemap',
          color: initiative.colorObject.hex(),
        },
      };
    }

    return {};
  }
}
